import { render, staticRenderFns } from "./shProduct.vue?vue&type=template&id=14b63544&scoped=true&"
import script from "./shProduct.vue?vue&type=script&lang=js&"
export * from "./shProduct.vue?vue&type=script&lang=js&"
import style0 from "./shProduct.vue?vue&type=style&index=0&id=14b63544&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b63544",
  null
  
)

export default component.exports